import { Grid, Stack } from "@mui/material";

import { ReactComponent as FinanceIcon } from "../../Assets/Images/FinanceICON.svg";
import ComingSoonPageLayout from "../../Components/organisms/ComingSoonLayout/ComingSoonPageLayout";

const ComingSoonPage = () => {
  return (
    <div>
      <Stack
        className="coming-soon-container"
        style={{
          maxHeight: "633px",
          borderRadius: "10px",
          backgroundColor: "white",
        }}
      >
        <ComingSoonPageLayout icon={<FinanceIcon />} />
      </Stack>
    </div>
  );
};

export default ComingSoonPage;
